const ABSOLUTE_URL_PATTERN = /^https?:\/\//i;
const configuredApiBaseUrl = (process.env.VUE_APP_API_BASE_URL || '').trim().replace(/\/+$/, '');

export function resolveApiUrl(apiPath = '') {
  if (!apiPath) {
    return '';
  }

  if (ABSOLUTE_URL_PATTERN.test(apiPath)) {
    return apiPath;
  }

  const normalizedApiPath = apiPath.startsWith('/') ? apiPath : `/${apiPath}`;
  return configuredApiBaseUrl
    ? `${configuredApiBaseUrl}${normalizedApiPath}`
    : normalizedApiPath;
}

export function getConfiguredApiBaseUrl() {
  return configuredApiBaseUrl;
}
